export class UndoMark
{
  undoInfo:string;
  redoInfo:string;
  private _position:number;
  get position(){ return this._position; }

  constructor( undoInfo:string, redoInfo:string, position:number )
  {
    this.undoInfo = undoInfo;
    this.redoInfo = redoInfo;
    this._position = position;
  }

}